import React, { useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import ClientesGodMode from "./ClientesGodMode";
import PlanosGodMode from "./PlanosGodMode";
import EstatisticasGodMode from "./EstatisticasGodMode";
import LogsGodMode from "./LogsGodMode";
import FinanceiroGodMode from "./FinanceiroGodMode";
import MigracaoPdfsGodMode from "./MigracaoPdfsGodMode";
import MensagensGodMode from "./MensagensGodMode";
import ParametrosGodMode from "./ParametrosGodMode";
import PageHeader from "../PageHeader/PageHeader";

function GodMode() {
  const [aba, setAba] = useState("clientes");

  return (
    <div>
      <PageHeader titulo="God Mode" path="/GodMode" />

      <Tab.Container activeKey={aba} onSelect={(k) => k && setAba(k)}>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="clientes">Clientes</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="planos">Planos</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="estatisticas">Estatisticas</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="logs">Logs</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="financeiro">Financeiro</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="migracaoPdfs">Migracao de PDFs</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="mensagens">Mensagens</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="parametros">Parâmetros</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="clientes">
            {aba === "clientes" && <ClientesGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="planos">
            {aba === "planos" && <PlanosGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="estatisticas">
            {aba === "estatisticas" && <EstatisticasGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="logs">
            {aba === "logs" && <LogsGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="financeiro">
            {aba === "financeiro" && <FinanceiroGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="migracaoPdfs">
            {aba === "migracaoPdfs" && <MigracaoPdfsGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="mensagens">
            {aba === "mensagens" && <MensagensGodMode />}
          </Tab.Pane>
          <Tab.Pane eventKey="parametros">
            {aba === "parametros" && <ParametrosGodMode />}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}

export default GodMode;
